import React, {
    useState,
    useEffect,
 
} from "react"
import {   Typography} from './ot'

const BaseListView1_3 = ({
    value = "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
    className = "text-gray-600 mt-0.5 text-xs sm:text-sm line-clamp-2",
    style = {},
    
}, ref) => {
    

    return (
        <Typography.P className={className} style={style}>
            {value}
        </Typography.P>
    )
}

export default BaseListView1_3
